import axios from "axios";
import api from "../api";
import filter_service from "./filter-service";

function getBrandById(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(api.brands + "/" + id)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function create(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(api.brands, params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function read(params = {}) {
  let pagination = params.with_pagination
    ? params.pagination
      ? `?isPaginated=1&page=${params.pagination.currentPage}&perPage=${params.pagination.perPage}`
      : "?isPaginated=1"
    : "";
  let paginate = params.with_pagination ? { paginate: true } : {};
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.brands}${pagination}`, params)
      .then((response) => {
        if (params.with_pagination) {
          resolve({
            brands: { ...paginate, ...response.data },
          });
        } else {
          resolve({
            brands: response.data,
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function update(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(api.brands + "/" + params.id, params)
      .then((response) => {
        resolve({
          brands: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}
async function destroy(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(api.brands + "/" + id)
      .then((response) => {
        resolve({
          brands: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getInverterBrands(params) {
  return new Promise((resolve, reject) => {
    let filter_params = filter_service.filter_params(params);
    axios
      .get(`${api.brands_inverters}${filter_params}`)
      .then((response) => {
        resolve({
          brands: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function attachFiles(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.brands}/${params.brand_id}/files`, params.file, {
        transformRequest: (data, headers) => {
          delete headers.common["Content-type"];
          return data;
        },
      })
      .then((response) => {
        resolve({
          product: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function removeFile(params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${api.brands}/${params.brand_id}/files`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  getBrandById,
  read,
  create,
  update,
  destroy,
  getInverterBrands,
  attachFiles,
  removeFile,
};
